import { networkActionsCreator } from '../../../../admincore'

const actions = {
  ...networkActionsCreator('trips/download'),
}

export default actions

export function load(params) {
  console.log('paramsssss', params)
  return {
    type: actions.LOAD,
    payload: {
      params,
    },
  }
}
